export const movePRStandardArticleBeforeButtonLoadMore = (
  targetSelector: string,
  prArticleWrapper: HTMLElement
) => {
  const prArticleHTML: string | null = prArticleWrapper.innerHTML;
  const htmlComment = '<!-- Reklamní pozice PR Standard -->';

  const loadMoreWrapper: HTMLElement | null = document.querySelector(`${targetSelector}`);
  if (loadMoreWrapper) {
    loadMoreWrapper.insertAdjacentHTML('beforebegin', `${htmlComment} ${prArticleHTML}`);
    prArticleWrapper.remove();
  } else {
    // vyjimka pro online přenosy, které typově nejsou článek a nevloží se tam kůvli tomu správný data wrapper selector
    const loadMoreWrapperOnlineGames: HTMLElement | null =
      document.querySelector('[data-insert-place]');

    if (loadMoreWrapperOnlineGames) {
      loadMoreWrapperOnlineGames.insertAdjacentHTML(
        'beforebegin',
        `${htmlComment} ${prArticleHTML}`
      );
      prArticleWrapper.remove();
    }
  }
};
